import { SdeData } from "./data";
import { cr } from "fire-wind-water";

const posterModel = {};
if (!posterModel.modules) {
  posterModel.modules = [];
}
class Poster {
  constructor() {
    this.instance = new SdeData();
    this.posterInfo = null;
    this.isPosterLoad = false;
    window.$sk.template.module(this);
  }

  module(o) {
    const key = `sk_temp_seminar_poster_${new Date().getTime()}`;
    posterModel.modules.push({
      key,
      model: o,
    });
    this.isPoster(o);
    return {
      unsubscribe() {
        posterModel.modules = posterModel.modules.filter((d) => {
          return d.key !== key;
        });
      },
    };
  }

  skPosterEnd(data) {
    cr.each(posterModel.modules, (d) => {
      if (d.model.skPosterEnd) {
        d.model.skPosterEnd(data);
      }
    });
  }

  skUserEnd() {
    this.getPoster();
  }

  getPoster() {
    const m = window.$sk.template.get();
    const o = {
      instanceId: m.common.instanceId,
      tenantId: m.common.tenantId,
    };
    this.instance.getInstanceStatus(o).subscribe((res) => {
      if (parseInt(res.status, 10) === 1) {
        this.getInstanceUrl(o);
      } else {
        this.isPosterLoad = true;
      }
    });
  }

  getInstanceUrl(o) {
    this.instance.getInstanceUrl(o).subscribe((res) => {
      this.posterInfo = res;
      this.isPosterLoad = true;
      this.skPosterEnd(this.posterInfo);
    });
  }

  isPoster(o) {
    if (this.isPosterLoad && o.skPosterEnd) {
      o.skPosterEnd(this.posterInfo);
    }
  }
}

if (!posterModel.poster) {
  posterModel.poster = new Poster();
}

export { posterModel };
